/**
 * STUDENT classroom for ONE cohort (A1). URL-addressable: an announcement's
 * or a notification's link can open the classroom directly.
 */
import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { StudentClassroomView } from "@/features/academy/components/classroom/student-classroom-view";

function StudentClassroomPage() {
  const params = useParams({ from: "/_app/classroom/$cohortId" });
  return <StudentClassroomView cohortId={params().cohortId} />;
}

export const classroomDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/classroom/$cohortId",
  component: StudentClassroomPage,
});
